import * as React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { ScrollArea } from "@/components/ui/scroll-area";
const termsSections = [{
  id: "tjenestebeskrivelse",
  title: "1. Tjenestebeskrivelse",
  content: "Xora leverer en skybasert programvareplattform (SaaS) som tilbyr AI-drevne automatiseringsverktøy spesielt utviklet for eiendomsmeglere. Tjenesten inkluderer, men er ikke begrenset til, automatisert prospektering, generering av markedsføringsmateriell, kundekommunikasjon og dataanalyse. Vi forbeholder oss retten til å oppdatere, endre eller fjerne funksjonalitet i tjenesten for å forbedre brukeropplevelsen eller av tekniske årsaker."
}, {
  id: "brukerens-ansvar",
  title: "2. Brukerens ansvar",
  content: "Som bruker av Xora forplikter du deg til å oppgi korrekt og oppdatert informasjon ved registrering. Du er personlig ansvarlig for å sikre din konto og passord mot uautorisert tilgang. Tjenesten skal kun benyttes til lovlige formål i tråd med gjeldende lover og regler for eiendomsmegling og markedsføring. Du er fullt ut ansvarlig for all aktivitet som skjer under din brukerkonto, inkludert innholdet som genereres og distribueres via plattformen."
}, {
  id: "ansvarsbegrensning",
  title: "3. Ansvarsbegrensning",
  content: "Xora-tjenesten leveres \"som den er\" og \"som tilgjengelig\". Vi garanterer ikke at tjenesten vil være feilfri, uavbrutt eller at alle AI-genererte resultater er 100% nøyaktige. Xora er under ingen omstendigheter ansvarlig for indirekte tap, tap av data, tapt fortjeneste, tap av goodwill eller andre følgeskader som oppstår som følge av bruk eller manglende evne til å bruke våre tjenester. Vårt totale ansvar overfor deg for eventuelle krav knyttet til tjenesten skal ikke overstige det beløpet du har betalt oss de siste 12 månedene."
}, {
  id: "immaterielle-rettigheter",
  title: "4. Immaterielle rettigheter",
  content: "All programvare, design, kildekode, algoritmer og annet innhold på Xora-plattformen tilhører oss eller våre lisensgivere og er beskyttet av opphavsrett og andre immaterielle rettigheter. Som bruker beholder du fullt eierskap til dine egne kundedata og innhold du laster opp. Ved å bruke tjenesten gir du imidlertid Xora en verdensomspennende, royaltyfri og begrenset lisens til å lagre, behandle og bruke disse dataene utelukkende for å kunne levere og forbedre tjenesten til deg."
}, {
  id: "personvern-og-datasikkerhet",
  title: "5. Personvern og datasikkerhet",
  content: "Vi tar ditt og dine kunders personvern på største alvor. All behandling av personopplysninger skjer i strengt samsvar med vår gjeldende personvernerklæring og EUs personvernforordning (GDPR). Som databehandler for dine kundedata, forplikter vi oss til å implementere og opprettholde passende tekniske og organisatoriske sikkerhetstiltak for å beskytte dataene mot uautorisert tilgang, endring eller sletting."
}, {
  id: "oppsigelse",
  title: "6. Oppsigelse",
  content: "Denne avtalen løper inntil den sies opp av en av partene. Du kan når som helst si opp ditt abonnement via dine kontoinnstillinger, med virkning fra utløpet av den inneværende faktureringsperioden. Xora forbeholder seg retten til å suspendere eller terminere din konto med umiddelbar virkning dersom vi har rimelig grunn til å tro at du har brutt disse brukervilkårene, misbrukt tjenesten, eller handlet i strid med gjeldende lovgivning."
}, {
  id: "generelle-juridiske-vilkar",
  title: "7. Generelle juridiske vilkår",
  content: "Disse brukervilkårene utgjør den fullstendige avtalen mellom deg og Xora vedrørende bruk av tjenesten. Vilkårene er underlagt og skal tolkes i samsvar med norsk lov. Eventuelle tvister som måtte oppstå i forbindelse med disse vilkårene, og som ikke kan løses i minnelighet gjennom forhandlinger, skal bringes inn for de ordinære domstoler med Oslo tingrett som vedtatt verneting."
}];
export default function TermsOfUse() {
  return <section id="brukervilkår" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {}
        <div className="mb-12 md:mb-16">
          <Breadcrumb className="mb-6">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/">Hjem</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Brukervilkår</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>

          <h1 className="font-default text-4xl md:text-5xl font-bold tracking-tight mb-4">
            Brukervilkår
          </h1>
          <p className="text-muted-foreground text-lg">
            Sist oppdatert: 24. oktober 2023
          </p>
        </div>

        <Separator className="mb-12" />

        {}
        <div className="flex flex-col lg:flex-row gap-12 items-start">
          {}
          <aside className="w-full lg:w-1/4 lg:sticky lg:top-24 shrink-0">
            <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
              <h3 className="font-default font-semibold text-lg mb-4">
                Innholdsfortegnelse
              </h3>
              <ScrollArea className="h-[calc(100vh-300px)] lg:h-auto">
                <nav className="flex flex-col gap-3">
                  {termsSections.map((section, i) => <div key={section.id} data-index={i}>
                      <Link to={`#${section.id}`} className="text-sm text-muted-foreground hover:text-primary transition-colors block py-1">
                        {section.title}
                      </Link>
                    </div>)}
                </nav>
              </ScrollArea>
            </div>
          </aside>

          {}
          <div className="w-full lg:w-3/4 max-w-3xl">
            <div className="prose prose-slate dark:prose-invert max-w-none">
              <p className="text-lg leading-relaxed mb-10 text-muted-foreground">
                Velkommen til Xora. Disse brukervilkårene regulerer din tilgang til og bruk av våre tjenester. 
                Vennligst les dem nøye før du tar i bruk plattformen. Ved å registrere en konto eller bruke 
                våre tjenester, aksepterer du å være bundet av disse vilkårene.
              </p>

              <div className="space-y-12">
                {termsSections.map((section, i) => <div key={section.id} id={section.id} data-index={i} className="scroll-mt-24">
                    <h2 className="font-default text-2xl font-semibold mb-4 text-foreground">
                      {section.title}
                    </h2>
                    <p className="text-muted-foreground leading-relaxed">
                      {section.content}
                    </p>
                  </div>)}
              </div>
            </div>

            <Separator className="my-12" />

            <div className="bg-secondary/50 rounded-xl p-8 text-center">
              <h3 className="font-default text-xl font-semibold mb-3">
                Har du spørsmål om våre vilkår?
              </h3>
              <p className="text-muted-foreground mb-6">
                Vårt supportteam er tilgjengelig for å hjelpe deg med eventuelle uklarheter.
              </p>
              <Link to="https://xora.no/kontakt/" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow hover:bg-primary/90 h-10 px-8 py-2">
                Kontakt oss
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}